import React, { Component } from 'react'
import './index.scss'
import area from "@/utils/area";
import { Form, Input, Select, message } from 'antd'

import formBg from '@/images/newHome/form_bg.png'
import userIcon from '@/images/newHome/user_icon.svg'
import phoneIcon from '@/images/newHome/phone_icon.svg'
import wechatIcon from '@/images/newHome/wechat_icon.svg'
import emailIcon from '@/images/newHome/email_icon.svg'
import selectDownIcon from '@/images/newHome/select_down.svg'

import { postSignup } from "src/apis/user"

import { subLogEvent } from '@/firebase'

class HtForm extends Component {

    state = {
        name: '',
        phoneCode: 86,
        phone: '',
        contact: '',
        email: '',
        verifyCode: "88888888",
        btnFlag: false
    }

    changeInput = (key, e) => {
        e.persist()
        let value = e.target.value
        this.setState({
            [key]: value
        })
    }

    changePhoneCode = (value) => {
        this.setState({
            phoneCode: value
        })
    }

    getUrlParam = (name) => {
        // 取得url中?后面的字符
        var query = window.location.hash.split("?")[1];
        // 把参数按&拆分成数组
        var param_arr = query ? query.split("&") : "";
        for (var i = 0; i < param_arr.length; i++) {
            var pair = param_arr[i].split("=");
            if (pair[0] == name) {
                return pair[1];
            }
        }
        return false;
    }

    validateForm = () => {
        const { name, phoneCode, phone, contact, email } = this.state
        if (!name) {
            return '请填写姓名'
        }
        if (!phoneCode) {
            return '请选择区号'
        }
        if (!phone) {
            return '请填写手机号'
        }
        if (!contact) {
            return '请填写微信号'
        }
        if (email && !/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z]{2,5}$/.test(email)) {
            return '邮箱格式错误'
        }
        return ''
    }

    resetForm = () => {
        this.setState({
            name: '',
            phoneCode: 86,
            phone: '',
            contact: '',
            email: '',
            verifyCode: "88888888",
            btnFlag: false
        })
    }

    submitForm = () => {
        if (this.state.btnFlag) {
            return
        }

        let errMsg = this.validateForm()
        const { name, phoneCode, phone, contact, email, verifyCode } = this.state
        // subLogEvent(`pcSubmit`, {
        //     name,
        //     phoneCode,
        //     phone,
        //     contact, 
        //     email, 
        //     verifyCode
        // })
        console.log(4477)
        if (errMsg) {
            return message.error(errMsg)
        }
        let data = {
            name,
            phoneCode,
            phone,
            contact,
            email,
            verifyCode,
            channelId: this.getUrlParam("channelId") || null,
            activityId: this.getUrlParam("activityId") || null,
            userId: this.getUrlParam("userId") || null,
        }

        if (this.getUrlParam("channelId") && this.getUrlParam("activityId")) {
            data.channelId = this.getUrlParam("channelId");
            data.activityId = this.getUrlParam("activityId");
            data.applySource = 6;
        } else {
            data.applySource = 5;
        }
        this.state.btnFlag = true
        postSignup(data).then((res) => {
            if (res.code === 200) {
                subLogEvent(`pcSubmitSuccess`, data)
                // window.ttq.track('SubmitForm', {
                //     "query": window.location.hash.split("?")[1],
                //     status: 'success',
                //     formData: data,
                //     // "test_event_code": 'TEST22538'
                // })
                this.props.history.push({
                    pathname: '/result',
                })
                // message.success('恭喜你报名成功')
                // this.resetForm()
            } else {
                subLogEvent(`pcSubmitError`, data)
                // window.ttq.track('SubmitForm', {
                //     "query": window.location.hash.split("?")[1],
                //     status: 'error',
                //     formData: data,
                //     // "test_event_code": 'TEST22538'
                // })
            }
        }).catch((err) => {
            subLogEvent(`pcSubmitError`, data)
            // window.ttq.track('SubmitForm', {
            //     "query": window.location.hash.split("?")[1],
            //     status: 'error',
            //     formData: data,
            //     // "test_event_code": 'TEST22538'
            // })
            message.error(err.data.msg)
        }).finally(() => {
            this.state.btnFlag = false
        })
    }

    render() {
        return (
            <div className='ht-form' style={{ backgroundImage: `url(${formBg})` }}>

                <div className='title-box'>
                    <h5 className='title'>免费领取</h5>
                    <h6 className='sub-title'>价值888元中文学习礼包</h6>
                </div>

                <div className='form-content'>
                    <ul className='form-list'>
                        <li className='form-list-item'>
                            <img className='input-icon' src={userIcon} />
                            <div className='input-box'>
                                <input className='input' placeholder='姓名/Name' value={this.state.name} onChange={this.changeInput.bind(this, 'name')} />
                            </div>
                        </li>
                        <li className='form-list-item'>
                            <img className='input-icon' src={phoneIcon} />
                            <div className='input-box phone-input-box'>

                                <div className='phone-code-box'>
                                    <Select
                                        showSearch
                                        style={{
                                            width: '90px',
                                            border: 'none',
                                            fontSize: '16px',
                                            color: '#000',
                                            cursor: 'point'
                                        }}
                                        suffixIcon={
                                            <img className='select-down-icon' src={selectDownIcon} />
                                        }
                                        value={this.state.phoneCode}
                                        placeholder="请选择地区"
                                        onChange={this.changePhoneCode}
                                    >
                                        {area.map((item, index) => (
                                            <Select.Option
                                                key={index}
                                                value={item.country_code}
                                            >
                                                +{item.country_code} {item.country_name_cn}({item.ab})
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </div>

                                <span className='line'></span>

                                <div className='input-box'>
                                    <input className='input' placeholder='手机号/Phone' value={this.state.phone} onChange={this.changeInput.bind(this, 'phone')} />
                                </div>

                            </div>
                        </li>
                        <li className='form-list-item'>
                            <img className='input-icon' src={wechatIcon} />
                            <div className='input-box'>
                                <input className='input' placeholder='微信/Wachat' value={this.state.contact} onChange={this.changeInput.bind(this, 'contact')} />
                            </div>
                        </li>
                        <li className='form-list-item'>
                            <img className='input-icon' src={emailIcon} />
                            <div className='input-box'>
                                <input className='input' placeholder='邮箱/Email（选填）' value={this.state.email} onChange={this.changeInput.bind(this, 'email')} />
                            </div>
                        </li>
                    </ul>

                    <div className='btn-box'>
                        <div className='btn' onClick={this.submitForm}>立即领取</div>
                    </div>
                </div>



            </div>
        )
    }
}

export default HtForm